export default __webpack_public_path__ + "static/media/Standard.09cd2bc7.svg";